import { GameType } from 'src/app/dashboard/modals/cxone-award-modal/cxone-award.model';
import _ from 'lodash';
import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { CvConfigurationService } from 'src/app/reusables/services/cv-configuration.service';
import { CvDialogService } from 'src/app/reusables/confirm-dialog/cv-dialog.service';
import { GamesService } from 'src/app/gamification/command-center/services/games.service';
import { GroupDetails } from './configure-eligibility-brackets.component.model';
import { OnChanges } from 'cv-ng-metadata/core';
import moment from 'moment';

@Component({
  selector: 'cv-configure-eligibility-brackets',
  templateUrl: './configure-eligibility-brackets.component.html',
  styleUrl: './configure-eligibility-brackets.component.scss'
})
export class ConfigureEligibilityBracketsComponent implements OnInit, OnChanges {
  @Input() step: number;
  @Input() componentOptions: any;
  @Output() componentComplete: EventEmitter<any> = new EventEmitter<any>();
  @Output() roundsChanged: EventEmitter<number> = new EventEmitter<number>();
  @Input() rankingData: any;
  @Input() loading: boolean = false;
  @Output() loadingChange = new EventEmitter<boolean>();

  gs: any = {
    modified: {
      item: {
        Eligibility: {
          AssignedGroups: {
            emp: []
          }
        }
      }
    }
  };
  assignToolVisible: boolean = false;
  empColumns = [];
  totEmpGroups: number = 0;
  totRecGroups: number = 0;
  empExpanded: boolean = false;
  recExpanded: boolean = false;
  secondLevelName: string = "";
  assignedGroups = [];
  rounds: (string | number)[] = [2, 3, 4];
  totalParticipants: number;
  participants: GroupDetails[] = [];
  pairs: { leftSide: GroupDetails[]; rightSide: GroupDetails[] } = { leftSide: [], rightSide: [] };

  numberSelectedParticipants: number = 0;
  participantsMap = {
    2: 4,
    3: 8,
    4: 16
  }
  leftPairs: any[] = [];
  rightPairs: any[] = [];
  gameStarted: boolean = false;
  isExpandedView: boolean = false;
  metricName: string = null;
  isCxone = false;
  gameType: number;
  isTournamentActive: boolean;

  constructor(
    private gamesService: GamesService,
    private dialogService: CvDialogService,
    private cdr: ChangeDetectorRef,
    private cvConfigurationService: CvConfigurationService,
  ) {
    this.gs = this.gamesService.data;
    $(document).on("AssignToolObjectiveSaveEvt", this.onAssignToolSave);
    if (!this.gs?.modified?.item) {
      this.gs = {
        modified: {
          item: {
            BracketTournamentDetails: {},
            BracketTournamentMatches: {},
            Eligibility: {
              AssignedGroups: {
                emp: [],
                rec: []
              }
            }
          }
        }
      };
    }
  }

  ngOnInit(): void {
    this.gameType = GameType.BracketTournament;
    this.pairs = { leftSide: [], rightSide: [] };
    if (this.gs.modified?.item?.underlyingRule) {
      this.gs.modified.item.underlyingRule.AutoJoin = true;
    }

    if (this.gs.modified.item.SelectedMetrics) {
      this.metricName = this.gs.modified.item.SelectedMetrics[0].abbrev;
    }

    this.gamesService.loadGroupTypes().then((result: any) => {
      this.secondLevelName = result.EmpGroupTypes.find((empGroup) => { return empGroup.GroupLevel == 2; }).GroupTypeName;
    });

    if (this.gs?.modified?.item?.Eligibility != undefined && this.gs.modified.item.Eligibility.AssignedGroups != undefined
      && this.gs.modified.item.Eligibility.AssignedGroups.emp != undefined) {
      this.setData();
    }

    if (!this.gs.modified.item.Eligibility.AssignedGroups.emp) {
      this.gs.modified.item.Eligibility.AssignedGroups.emp = []
    }

    this.checkGameStarted();
    this.setParticipants();
    this.processRounds();
    this.isCxone = this.cvConfigurationService.isCxOne;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.gs && !changes.gs.firstChange) {
      this.handleParticipantsAndPairs();
    }
    if (changes.rankingData && changes.rankingData.currentValue) {
      this.gs.modified.item.ranking = changes.rankingData.currentValue;
      this.metricName = this.gs.modified.item.ranking[0].MetricName;
      this.generateParticipants();
      this.createPairs();
    }
  }

  setData(): void {
    this.empExpanded = false;
    this.recExpanded = false;

    if (this.gs.modified.item.Eligibility.AssignedGroups.emp.length > 0) {
      this.empColumns = this.gs.modified.item.Eligibility.AssignedGroups.emp;
      this.totEmpGroups = this.empColumns.length;
    }

    this.empColumns.sort((a, b) => {
      if (a.GroupName < b.GroupName)
        return -1;

      if (a.GroupName > b.GroupName)
        return 1;

      return 0;
    });

    this.empColumns = this.columnize(this.empColumns.slice(0, 21));
  }

  setParticipants(): void {
    if (!this.gs?.modified?.item?.BracketTournamentDetails) {
      this.gs.modified.item.BracketTournamentDetails = {
        isRanked: true,
        NumberOfRounds: '2',
        GameStarted: this.gameStarted,
        BracketVersion: 0
      };
      const rounds = this.gs.modified.item.BracketTournamentDetails.NumberOfRounds;
      this.totalParticipants = this.participantsMap[rounds];
    } else {
      const rounds = this.gs.modified.item.BracketTournamentDetails.NumberOfRounds;
      this.totalParticipants = this.participantsMap[rounds];
      this.gs.modified.item.BracketTournamentDetails.totalParticipants = this.totalParticipants;
    }

    if (!this.gs.modified.item.BracketTournamentMatches) {
      this.gs.modified.item.BracketTournamentMatches = {
        rightSide: [],
        leftSide: []
      };
    } else {
      const rightPairs = this.gs.modified.item.BracketTournamentMatches.rightSide;
      const leftPairs = this.gs.modified.item.BracketTournamentMatches.leftSide;
      this.pairs = { leftSide: leftPairs, rightSide: rightPairs };
    }
    if (this.gs.modified.item.underlyingRule.IsCopy || (!this.gameStarted && this.gs.modified.item.underlyingRule.RuleID > 0
        && new Date() < new Date(this.gs.modified.item.BracketTournamentRounds[this.gs.modified.item.BracketTournamentRounds.length - 1].EndDate))) {
      this.handleParticipantsAndPairs();
    }

  }

  columnize(arr) {
    var newArr = [];

    for (var i = 0; i < 3; i++) {
      var tmpArray = [];
      for (var j = i; j < arr.length; j += 3) {
        tmpArray.push(arr[j]);
      }
      newArr.push(tmpArray);
    }

    return newArr;
  }

  getGroupType(type: string): string {
    if (this.gs.modified.item.Eligibility.AssignedGroups.emp != undefined || this.gs.modified.item.Eligibility.AssignedGroups.rec != undefined) {
      switch (type) {
        case 'emp':
          if (this.gs.modified.item.Eligibility.AssignedGroups.emp.length > 0) {
            var gtmatch = this.gs.GroupTypes.filter((gt) => { return gt.BaseGroupType == 0 && gt.GroupLevel == this.gs.modified.item.Eligibility.AssignedGroups.emp[0].GroupLevel });
            if (gtmatch != null && gtmatch.length > 0)
              return gtmatch[0].GroupTypeName;
          }
          break;
        case 'rec':
          if (this.gs.modified.item.Eligibility.AssignedGroups.rec.length > 0) {
            var gtmatch = this.gs.GroupTypes.filter((gt) => { return gt.BaseGroupType == 1 && gt.GroupLevel == this.gs.modified.item.Eligibility.AssignedGroups.rec[0].GroupLevel });
            if (gtmatch != null && gtmatch.length > 0)
              return gtmatch[0].GroupTypeName;
          }
          break;
      }
    }
  }

  deleteSelection(type: string): void {
    this.dialogService.showConfirmDialog(
      this.getLocalizedMessage("Confirm_Remove", "Confirm Remove"),
      this.getLocalizedMessage("Confirm_Remove_Message", "Are you sure you want to remove this group of participants?"),
      false,
      () => {
        if (type == 'emp') {
          this.gs.modified.item.Eligibility.AssignedGroups.emp = [];
          this.gs.modified.item.BracketTournamentDetails.totalParticipants = 0;
          this.gs.modified.item.BracketTournamentMatches = {
            rightSide: [],
            leftSide: []
          };
          this.totEmpGroups = 0;
          this.pairs = { leftSide: [], rightSide: [] };
        }

        if (type == 'rec') {
          this.gs.modified.item.Eligibility.AssignedGroups.rec = [];
        }
      }
    );
  }

  setAssignToolData() {
    const assignedGroups = { ...this.gs.modified.item.Eligibility.AssignedGroups };
    if (assignedGroups && assignedGroups.emp && assignedGroups.rec) {
      const { emp, rec } = assignedGroups;
      this.assignedGroups = [...emp, ...rec];
    }
    this.assignToolVisible = true;
  }

  onAssignToolSave = async (args: any) => {
    //Timeout required because this event and the one that sets the AssignedGroups.emp/rec lists both happen at the same time, thus this event can hit first (causing an undefined propery index error)    
    if (args.length > 0) {
      setTimeout(() => {
        if (this.assignedGroups.length > 0) {
          this.gs.modified.item.Eligibility.AssignedGroups = [];

          let tmpObj = angular.copy(this.assignedGroups);
          const emp = tmpObj.filter((g) => { return g.BaseGroupType == 0 });
          const rec = tmpObj.filter((g) => { return g.BaseGroupType == 1 });
          this.gs.modified.item.Eligibility.AssignedGroups = {
            emp,
            rec
          };

          this.setData();
          var eventArgs = {
            currentStep: this.step - 1,
            unlocks: this.componentOptions.unlocks
          };
          this.componentComplete.emit(eventArgs);

          //setting pairs
          this.handleParticipantsAndPairs();
        }
      }, 1);
    } else {
      this.gs.modified.item.Eligibility.AssignedGroups = { emp: [], rec: [] };
      this.gs.modified.item.BracketTournamentMatches = {
        rightSide: [],
        leftSide: []
      };
      this.pairs = {leftSide: [], rightSide: []}
    }
  }

  getLocalizedMessage(key: string, value: string): string {
    return this.gamesService.getLocalizedMessage(key, value);
  }

  getEligibilityDescription(eligibilityAllowed: string) {
    const defaultText =
      `Select "${eligibilityAllowed}" to participate in the game. Each "${eligibilityAllowed}" will be automatically added to the game. Only "${eligibilityAllowed}" are eligible to play this game.`
    const localizedMessage = this.getLocalizedMessage('Eligibility_Description', defaultText);
    return localizedMessage.replaceAll("{{0}}", eligibilityAllowed);
  }

  updateTotalParticipants(rounds: number) {
    this.gs.modified.item.BracketTournamentDetails.NumberOfRounds = rounds;
    this.totalParticipants = this.participantsMap[rounds];
    if (this.totEmpGroups > 0) {
      this.changeOrder();
    }
    this.handleParticipantsAndPairs();
    this.roundsChanged.emit(this.gs.modified.item.BracketTournamentDetails.NumberOfRounds);
  }

  async handleParticipantsAndPairs() {
    this.generateParticipants();
    if (!this.gs.modified.item.BracketTournamentDetails.isRanked && this.totEmpGroups > 0) {
      this.shuffleParticipants();
    } else {
      if (this.gs.modified.item.SelectedMetrics && this.gs.modified.item.SelectedMetrics[0].metricID) {
        this.loadingChange.emit(true);
        await this.obtainParticipantsRanking();
        this.loadingChange.emit(false);
      }
    }
    this.createPairs();
  }

  generateParticipants() {
    if (this.gs.modified.item.Eligibility && this.gs.modified.item.Eligibility.AssignedGroups.emp) {
      let empGroups = this.gs.modified.item.Eligibility.AssignedGroups.emp;

      if (empGroups.length > this.totalParticipants) {
        empGroups = empGroups.slice(0, this.totalParticipants);
        this.gs.modified.item.Eligibility.AssignedGroups.emp = empGroups;
      }

      this.participants = empGroups;
      this.totEmpGroups = this.gs.modified.item.Eligibility.AssignedGroups.emp.length;
    } else {
      this.participants = [];
      this.totEmpGroups = 0;
    }
  }

  shuffleParticipants() {
    for (let i = this.participants.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [this.participants[i], this.participants[j]] = [this.participants[j], this.participants[i]];
    }
  }

  createPairs() {
    this.pairs = { leftSide: [], rightSide: [] };
    const totalParticipants = this.participants.length;
    const totalPairs = totalParticipants / 2;
    const pairsPerSide = totalPairs / 2;

    this.leftPairs = [];
    this.rightPairs = [];

    if (!this.gs.modified.item.BracketTournamentMatches) {
      this.gs.modified.item.BracketTournamentMatches = {};
    }

    if (this.gs.modified.item.BracketTournamentDetails.isRanked && this.gs.modified.item.ranking !== undefined && this.gs.modified.item.ranking.length > 0) {
      let ranking = this.gs.modified.item.ranking;
      let pairs = [];
      const allNull = ranking.every(item => item.MetricData?.MetricValue === null);
      const firstValue = ranking[0].MetricData?.MetricValue;
      
      const allEqual = //tie
        firstValue !== null &&
        ranking.every((item) => item.MetricData?.MetricValue === firstValue);

      if (allNull || allEqual) {
        // Sort alphabetically by group name
        ranking.sort((a, b) => {
          const nameA = a.Group?.GroupName || "";
          const nameB = b.Group?.GroupName || "";
          return nameA.localeCompare(nameB);
        });
      }

      if (allNull || allEqual) {
        for (let i = 0; i < ranking.length; i += 2) {
          if (i + 1 < ranking.length) {
            pairs.push([ranking[i], ranking[i + 1]]);
          } else {
            pairs.push([ranking[i]]);
          }
        }
      }
      else {
        // Matching the top-ranked participant with the lowest-ranked one
        let i = 0, j = ranking.length - 1;
        while (i < j) {
          pairs.push([ranking[i], ranking[j]]);
          i++;
          j--;
        }
        // If there's an odd number of participants, the middle one remains unpaired
        if (i === j) {
          pairs.push([ranking[i]]);
        }
      }

      const combinedDetails = pairs.map(pair =>
        pair.map(group => this.participants.find(participant => participant.GroupID === group.Group.GroupID))
      );

      let totalRequiredPairs = pairsPerSide * 2;

      if (combinedDetails.length < totalRequiredPairs) {
        const padding = totalRequiredPairs - combinedDetails.length;
        const emptyPairs = Array(padding).fill([]); //create an array with empty arrays
        combinedDetails.push(...emptyPairs); //add empty pairs at the end
      }

      //distribute the pairs alternately between the left and right sides, one by one
      this.leftPairs = [];
      this.rightPairs = [];
      if (allNull || allEqual) {
        // Fill the left side first and then the right side to maintain alphabetical order
        for (let i = 0; i < combinedDetails.length; i++) {
          if (this.leftPairs.length < pairsPerSide) {
            this.leftPairs.push(combinedDetails[i]);
          } else {
            this.rightPairs.push(combinedDetails[i]);
          }
        }
      } else {
        combinedDetails.forEach((pair, index) => {
          if (index % 2 === 0) {
            this.leftPairs.push(pair); //add to left side
          } else {
            this.rightPairs.push(pair); //add to right side
          }
        });
      }

      //add empty pairs if needed to balance the sides
      while (this.leftPairs.length < pairsPerSide) {
        this.leftPairs.push([]);
      }
      while (this.rightPairs.length < pairsPerSide) {
        this.rightPairs.push([]);
      }
    } else {
      for (let i = 0; i < this.participants.length; i += 2) {
        if (this.participants[i + 1]) {
          const pair = [this.participants[i], this.participants[i + 1]];
          if (this.leftPairs.length < pairsPerSide) {
            this.leftPairs.push(pair);
          } else {
            this.rightPairs.push(pair);
          }
        } else {
          const pair = [this.participants[i]];
          if (this.leftPairs.length < pairsPerSide) {
            this.leftPairs.push(pair);
          } else {
            this.rightPairs.push(pair);
          }
        }
      }

      while (this.leftPairs.length < pairsPerSide) {
        this.leftPairs.push([]);
      }
      while (this.rightPairs.length < pairsPerSide) {
        this.rightPairs.push([]);
      }
    }

    this.pairs = { leftSide: this.leftPairs, rightSide: this.rightPairs };

    this.gs.modified.item.BracketTournamentMatches.rightSide = this.rightPairs;
    this.gs.modified.item.BracketTournamentMatches.leftSide = this.leftPairs;
    this.gs.modified.item.BracketTournamentDetails.totalParticipants = this.totalParticipants;
  }

  getImageSrc(imageID: number | null): string | null {
    return imageID !== 0 ? `../Admin/ImageResizer.aspx?imgid=${imageID}&w=40&h=40` : `../Admin/ImageResizer.aspx?imgid=${null}&w=40&h=40`;
  }

  isButtonVisible(): Boolean {
    const details = this.gs.modified.item.BracketTournamentDetails;
    return details && this.totalParticipants > this.totEmpGroups;
  }

  async onRankedChange() {
    this.changeOrder();
  }

  async changeOrder() {
    if (this.gs && this.gs.modified && this.gs.modified.item && this.gs.modified.item.Eligibility &&
      this.gs.modified.item.Eligibility.AssignedGroups &&
      this.gs.modified.item.Eligibility.AssignedGroups.emp &&
      this.gs.modified.item.Eligibility.AssignedGroups.emp.length > 0) {
      if (this.gs.modified.item.BracketTournamentDetails.isRanked && (this.gs.modified.item.SelectedMetrics && this.gs.modified.item.SelectedMetrics[0].metricID)) {
        let leftArrays: GroupDetails[] = this.pairs.leftSide.flat(1);
        let rightArrays: GroupDetails[] = this.pairs.rightSide.flat(1);

        // Combine both flattened arrays
        let leftParticipants: GroupDetails[] = leftArrays;
        let rightParticipants: GroupDetails[] = rightArrays;

        // Concatenate to form the final list of participants
        let currentParticipants: GroupDetails[] = leftParticipants.concat(rightParticipants);

        // Assign the result to this.participants
        this.participants = currentParticipants;

        if (currentParticipants.length > this.totalParticipants) {
          this.participants = currentParticipants.slice(0, this.totalParticipants);
          this.gs.modified.item.Eligibility.AssignedGroups.emp = this.participants;
        }
        await this.obtainParticipantsRanking();
        this.createPairs();
      } else {
        this.handleParticipantsAndPairs();
      }
    }
  }

  async obtainParticipantsRanking(startDate: string | null = null, endDate: string | null = null) {
    if (this.gs.modified.item.SelectedMetrics && this.gs.modified.item.SelectedMetrics[0].metricID && this.gs.modified.item.Eligibility.AssignedGroups.emp.length > 0) {
      const metricID = this.gs.modified.item.SelectedMetrics[0].metricID;
      this.loadingChange.emit(true);
      let ranking = await this.gamesService.LoadMetricRanking(metricID, this.gs.modified.item.Eligibility.AssignedGroups.emp, startDate, endDate);
      this.loadingChange.emit(false);
      this.metricName = ranking.MetricName;
      this.gs.modified.item.ranking = ranking.RowData;
    }
  }

  checkGameStarted() {
    const rounds = this.gs.modified.item.BracketTournamentRounds;
    if (rounds && rounds.length > 0) {
      const firstRound = rounds[0];
      const currentDate = new Date(Date.now());
      const startDate = new Date(firstRound.StartDate);
      const lastRoundDate = new Date(rounds[rounds.length - 1].EndDate);
      const today = moment();

      this.gameStarted = (currentDate > startDate) && (lastRoundDate > currentDate);
      this.gs.modified.item.BracketTournamentDetails.GameStarted = this.gameStarted;

      //validating if the game has ended to clear round data 
      rounds.forEach(round => {
        if (!round.RoundName) {
          round.EndDate = new Date(round.EndDate);
        }
      });
  
      this.isTournamentActive = moment(rounds[rounds.length - 1].EndDate).isAfter(today);
  
      if (!this.isTournamentActive) {
        if (this.gs.modified.item.BracketTournamentMatches) {
          this.gs.modified.item.BracketTournamentMatches.leftSide = 
            Array.isArray(this.gs.modified.item.BracketTournamentMatches.leftSide) 
              ? this.gs.modified.item.BracketTournamentMatches.leftSide.slice(0, 1) 
              : [];
              
          this.gs.modified.item.BracketTournamentMatches.rightSide = 
            Array.isArray(this.gs.modified.item.BracketTournamentMatches.rightSide) 
              ? this.gs.modified.item.BracketTournamentMatches.rightSide.slice(0, 1) 
              : [];
        }

        if (this.pairs) {
          this.pairs.leftSide = Array.isArray(this.pairs.leftSide) ? this.pairs.leftSide.slice(0, 1) : [];
          this.pairs.rightSide = Array.isArray(this.pairs.rightSide) ? this.pairs.rightSide.slice(0, 1) : [];
        }
        this.handleParticipantsAndPairs();
      } // end: validating if the game has ended to clear round data 
      
      if (!this.gameStarted && lastRoundDate < currentDate) {
        this.gs.modified.item.BracketTournamentDetails.BracketVersion++;
      }
    }
  }
  

  openExpandedView(event: Event) {
    event.preventDefault();
    this.isExpandedView = true;
  }

  closeExpandedView(event: Event) {
    event.preventDefault();
    this.isExpandedView = false;
  }

  async processRounds() {
    const currentDate = new Date();

    if (this.gs.modified.item.BracketTournamentRounds && this.gs.modified.item.BracketTournamentRounds.length > 0) {
      const finishedRounds = this.gs.modified.item.BracketTournamentRounds.filter(round => new Date(round.EndDate) < currentDate);

      for (let round of finishedRounds) {
        const { StartDate, EndDate, RoundID } = round;

        await this.obtainParticipantsRanking(StartDate, null); //The end date is sent as null because it will be calculated based on the start date.

        const updateMetricValues = (matchArray: any[]) => {
          matchArray.forEach(matchRound => {
            if (Array.isArray(matchRound)) {
              matchRound.forEach(match => {
                if (match.RoundID === RoundID) {
                  let participant = this.gs.modified.item.ranking.find(p => p.Group.GroupID === match.GroupID);
                  if (participant) {
                    match.metricValue = participant.MetricData.MetricDisplayValue;
                  }
                }
              });
            }
          });
        };

        if (this.gs.modified.item.BracketTournamentMatches) {
          if (Array.isArray(this.gs.modified.item.BracketTournamentMatches.rightSide)) {
            updateMetricValues(this.gs.modified.item.BracketTournamentMatches.rightSide);
          }
          if (Array.isArray(this.gs.modified.item.BracketTournamentMatches.leftSide)) {
            updateMetricValues(this.gs.modified.item.BracketTournamentMatches.leftSide);
          }
        }
      }
    }
  }

  changeLoading(newValue: boolean) {
    this.loadingChange.emit(newValue);
  }

}
